<template>
  <div class="home-wrapper container-fluid">
    <div class="row">
      <div class="col-6">
        <div class="card mb-2">
          <div class="card-title text-center">
            <h5>API server</h5>
          </div>
          <div class="card-body">
            <iframe
              src="https://testapi-funxtioninteractive.cms-ds.com/monitor/d-solo/9iEumZy7k/nginx?orgId=1&theme=light&panelId=76"
              width="100%"
              height="300"
              frameborder="0"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>